export default __webpack_public_path__ + "static/12-f7ace7b4105386a10c24613df2dd266a.png";